'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var generatedCraftcms = require('@liquorice/generated-craftcms');
var material = require('@mui/material');
var reactHookForm = require('react-hook-form');
var createFieldControl = require('../lib/form/createFieldControl.js');
var FieldErrors = require('./FieldErrors/FieldErrors.js');

const FIELD_AGREE_FRAGMENT = generatedCraftcms.gql(`
  fragment fieldAgree on Field_Agree {
    ...fieldBase
    __typename
    uncheckedValue
    checkedValue
    descriptionHtml
    defaultState
  }
`);
const Field_Agree = createFieldControl.createField(FIELD_AGREE_FRAGMENT, (field, { methods })=>{
    const { label, handle, instructions, descriptionHtml, checkedValue, // uncheckedValue,
    labelPosition, defaultValue = null } = field;
    var _field_required;
    const required = (_field_required = field.required) != null ? _field_required : false;
    const uncheckedValue = null;
    const { control } = methods;
    const { field: fieldControl, fieldState: { error } } = reactHookForm.useController({
        name: handle,
        control,
        defaultValue
    });
    return /*#__PURE__*/ jsxRuntime.jsxs(material.FormControl, {
        required: required,
        error: !!error,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx(material.FormLabel, {
                component: "legend",
                sx: {
                    mb: 1
                },
                hidden: labelPosition === 'hidden',
                children: label
            }),
            /*#__PURE__*/ jsxRuntime.jsx(material.FormControlLabel, {
                componentsProps: {
                    typography: {
                        color: 'inherit'
                    }
                },
                required,
                label: /*#__PURE__*/ jsxRuntime.jsx(material.Typography, {
                    component: "span",
                    children: descriptionHtml
                }),
                control: /*#__PURE__*/ jsxRuntime.jsx(material.Checkbox, {
                    onChange: (_e, checked)=>fieldControl.onChange(checked ? checkedValue : uncheckedValue),
                    checked: fieldControl.value === checkedValue,
                    value: checkedValue
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx(material.FormHelperText, {
                children: instructions
            }),
            /*#__PURE__*/ jsxRuntime.jsx(FieldErrors, {
                errors: error
            })
        ]
    });
});

exports.FIELD_AGREE_FRAGMENT = FIELD_AGREE_FRAGMENT;
exports.Field_Agree = Field_Agree;
